import * as endSession from 'helpers/endSession'
import { clearLogoutLocalState } from 'helpers/clearLogoutLocalState'

let cleanupInFlight = false

export function forceSessionCleanup(): void {
  if (cleanupInFlight) {
    return
  }

  cleanupInFlight = true
  clearLogoutLocalState()
  endSession.redirectToEndSession()
}

export function resetSessionCleanupGuard(): void {
  cleanupInFlight = false
}
